'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _grayPercentage = require('gray-percentage');

var _grayPercentage2 = _interopRequireDefault(_grayPercentage);

var _typographyBreakpointConstants = require('typography-breakpoint-constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var theme = {
  title: 'Grand View',
  baseFontSize: '16px',
  baseLineHeight: 1.6875,
  googleFonts: [{
    name: 'Montserrat',
    styles: ['700']
  }, {
    name: 'Arvo',
    styles: ['400', '400i', '700']
  }],
  headerFontFamily: ['Montserrat', 'sans-serif'],
  bodyFontFamily: ['Arvo', 'sans-serif'],
  headerColor: 'hsla(0,0%,0%,1)',
  bodyColor: 'hsla(0,0%,0%,0.8)',
  headerWeight: 700,
  bodyWeight: 400,
  boldWeight: 700,
  overrideStyles: function overrideStyles(_ref, options) {
    var adjustFontSizeTo = _ref.adjustFontSizeTo,
        scale = _ref.scale,
        rhythm = _ref.rhythm;
    return _defineProperty({
      a: {
        color: '#d65947',
        textDecoration: 'none'
      },
      'a:hover,a:active': {
        color: options.bodyColor
      },
      'h1,h2,h3,h4,h5,h6': {
        marginTop: rhythm(2)
      },
      blockquote: _extends({}, scale(1 / 5), {
        color: (0, _grayPercentage2.default)(41),
        paddingLeft: rhythm(13 / 16),
        marginLeft: 0,
        borderLeft: rhythm(3 / 16) + ' solid #fca206'
      }),
      'blockquote > :last-child': {
        marginBottom: 0
      },
      'blockquote cite': _extends({}, adjustFontSizeTo(options.baseFontSize), {
        color: options.bodyColor,
        fontWeight: options.bodyWeight
      }),
      'blockquote cite:before': {
        content: '"— "'
      }
    }, _typographyBreakpointConstants.MOBILE_MEDIA_QUERY, {
      blockquote: {
        marginLeft: rhythm(-3 / 4),
        marginRight: 0,
        paddingLeft: rhythm(9 / 16)
      }
    });
  }
};

exports.default = theme;


//////////////////
// WEBPACK FOOTER
// ./~/typography-theme-grand-view/dist/index.js
// module id = 227
// module chunks = 35783957827783 107818501498521 231608221292675